import { v4 as uuidv4 } from 'uuid'
import { productAVMtypes } from '@/components/MedicalSearch/config/constants'

import usePerson from '@/hooks/usePerson'

// Hooks
const { personsDetails } = usePerson()

function _transferProductDoctor(doctor) {
  const { address } = doctor
  return {
    country: address.country,
    doctorId: uuidv4(),
    name: [doctor.firstName, doctor.lastName].join(' ').trim(),
    street: [address.street, address.houseNumber].join(' ').trim(),
    town: [address.zipCode, address.town].join(' ').trim(),
    zsrNumber: doctor.zsrNumber,
  }
}

export default function useDoctor() {
  function getDoctorName(doctor) {
    if (!doctor) {
      return undefined
    }

    const transformedDoctor = _transferProductDoctor(doctor)
    return `${transformedDoctor.name}, ${transformedDoctor.town}`
  }

  function getDoctorFromPerson(personId) {
    const person = personsDetails.value[personId]

    return getMedicalProduct(person)?.doctor
  }

  function getMedicalProduct(person) {
    return person.selectedProducts.find(product => {
      return product.selected && product.doctor
    })
  }

  /**
   * Returns doctors that could be transferred from another person.
   * Adults can only copy from other adults, children only from children.
   * @param persons
   * @param currentPersonId
   * @returns {*}
   */
  function getTransferableDoctorFromOtherPerson(persons, currentPersonId) {
    const adultAge = 18
    const currentPerson = persons.find(p => p.personId === currentPersonId)

    const haveSameAgeGroup = (person, otherPerson) => {
      if (person.personId === otherPerson.personId) return false
      if (person.age >= adultAge && otherPerson.age >= adultAge) return true
      if (person.age < adultAge && otherPerson.age < adultAge) return true
      return false
    }

    return (
      persons
        // can only transfer doctor within same age group
        .filter(p => haveSameAgeGroup(p, currentPerson))
        .filter(person => getMedicalProduct(person))
        .map(person => {
          const sourceProduct = getMedicalProduct(person)
          return {
            productId: sourceProduct.productId,
            source: person.personId,
            doctor: sourceProduct.doctor,
          }
        })
    )
  }

  function appliesToProduct(productId, doctor) {
    const searchKey = productAVMtypes[productId]
    return !!doctor.medicalOfficeNets.find(n => n.avmDefinition === searchKey)
  }

  return {
    appliesToProduct,
    getDoctorName,
    getDoctorFromPerson,
    getTransferableDoctorFromOtherPerson,
  }
}
